import { render } from "./MoatTrend.vue?vue&type=template&id=68e7901a"
import script from "./MoatTrend.vue?vue&type=script&lang=js"
export * from "./MoatTrend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__